/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'underscore',
	'react',
	'prop-types',
	'./internal/ForecastPredictComponents',
	'./internal/ForecastTitleDiv'
], function(_, React, PropTypes, ForecastPredictComponents, ForecastTitleDiv) {

	class ForecastFlyoutComponent extends React.Component {
		static propTypes = {
			initialState: PropTypes.shape({
				toggleEnabled: PropTypes.bool,
				settings: PropTypes.array
			}),
			onForecastValuesStateChanged: PropTypes.func
		};
		constructor(props) {
			super(props);
			this.state = {
				toggleEnabled: this.props.initialState.toggleEnabled,
				settings: this.props.initialState.settings
			};
		}
		_updateForecastState(newState) {
			this.props.onForecastValuesStateChanged(_.clone(newState));
		}

		/*
		* Toggle switch state changed.
		*/
		onToggleChange() {
			// Copy the current state, making the needed change, then set the state to cause a re-render
			const newState = _.extend({}, this.state, { toggleEnabled: !this.state.toggleEnabled });
			this.setState(newState);

			// Update the parent to set the state in the model	
			this._updateForecastState(newState);
		}
		predictSettingsChanged(settings) {
			// Copy the current state, making the needed change, then set the state to cause a re-render
			const newState = _.extend({}, this.state, { settings: settings });
			// Update the parent to set the state in the model
			this._updateForecastState(newState);
		}
		render() {
			return (
				<div className='forecastComponents'>
					<ForecastTitleDiv
						onToggleChange={() => this.onToggleChange()}
						toggleEnabled={this.state.toggleEnabled}
					/>
					<ForecastPredictComponents
						settings = {this.state.settings}
						isDisabled={!this.state.toggleEnabled}
						onForecastPredictItemsChanged = {predictItems => this.predictSettingsChanged(predictItems)}
					/>
				</div>
			);
		}
	}
	return ForecastFlyoutComponent;
});